/* Mini-Warenkorb, neues Design 2026 (snippets/cart-mini.liquid, templates/cart.mini.liquid)
   Öffnen, Schließen und Neuladen nach "In den Warenkorb" macht weiterhin atlantic.js.
   Hier: Mengen-Knöpfe, Entfernen, Escape-Taste und die Animation nur beim Öffnen. */
(function () {
  var el = document.querySelector('[data-cart-mini].sdmk');
  if (!el || !window.fetch) return;

  var aufWarenkorbSeite = /^\/cart\/?$/.test(window.location.pathname);
  var json = { 'Content-Type': 'application/json', 'Accept': 'application/json' };
  var beschaeftigt = false;

  function vorlage(doc, name) {
    var t = doc.querySelector('template[data-html="' + name + '"]');
    return t ? t.innerHTML : '';
  }

  function neuLaden() {
    var ansicht = fetch('/cart?view=mini', { credentials: 'same-origin' })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        el.querySelector('[data-cart-mini-content]').innerHTML = vorlage(doc, 'content');
        el.querySelector('[data-cart-mini-footer]').innerHTML = vorlage(doc, 'footer');
      });
    var anzahl = fetch('/cart.js', { headers: json, credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        // Konfigurator: Aufpreis-Zeilen (properties._k3d_zu) zählen nicht als Artikel (wie in atlantic.js)
        var n = (cart.items || []).reduce(function (s, it) {
          return it.properties && it.properties._k3d_zu ? s : s + it.quantity;
        }, 0);
        Array.prototype.forEach.call(document.querySelectorAll('[data-cart-mini-count]'), function (z) {
          z.textContent = n === 0 ? '' : n;
        });
      });
    return Promise.all([ansicht, anzahl]);
  }

  function aendern(artikel, menge) {
    if (beschaeftigt) return;
    beschaeftigt = true;
    artikel.classList.add('is-laedt');
    el.classList.add('sdmk-ruhig');
    fetch('/cart/change.js', {
      method: 'POST', headers: json, credentials: 'same-origin',
      body: JSON.stringify({ id: artikel.getAttribute('data-sdmk-artikel'), quantity: menge })
    })
      .then(function () {
        // Auf der Warenkorb-Seite die Seite neu laden, damit Tabelle und Mini-Warenkorb gleich sind
        if (aufWarenkorbSeite) { window.location = '/cart'; return; }
        return neuLaden();
      })
      .catch(function () { artikel.classList.remove('is-laedt'); })
      .then(function () { beschaeftigt = false; });
  }

  // capture: atlantic.js stoppt Klicks im Fenster (stopPropagation), deshalb vorher abfangen
  el.addEventListener('click', function (e) {
    var knopf = e.target.closest('[data-sdmk-menge], [data-sdmk-entfernen]');
    if (!knopf || knopf.disabled) return;
    var artikel = knopf.closest('[data-sdmk-artikel]');
    if (!artikel) return;
    e.preventDefault();
    var menge = knopf.hasAttribute('data-sdmk-entfernen') ? 0 : parseInt(knopf.getAttribute('data-sdmk-menge'), 10);
    if (isNaN(menge) || menge < 0) return;
    aendern(artikel, menge);
  }, true);

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && el.classList.contains('cart-mini-open')) {
      el.querySelector('[data-cart-mini-close]').click();
    }
  });

  // Beim Öffnen: Fokus aufs Schließen-Kreuz. Beim Schließen: Animation fürs nächste Öffnen wieder frei.
  var warOffen = false;
  new MutationObserver(function () {
    var offen = el.classList.contains('cart-mini-open');
    if (offen && !warOffen) {
      var zu = el.querySelector('[data-cart-mini-close]');
      if (zu) setTimeout(function () { zu.focus({ preventScroll: true }); }, 50);
    }
    if (!offen && warOffen) el.classList.remove('sdmk-ruhig');
    warOffen = offen;
  }).observe(el, { attributes: true, attributeFilter: ['class'] });
})();
